module.exports = __webpack_public_path__ + "static/media/p2preview.7a7f92a3.jpg";